/* Bluebells cart extras
   1. Repeats the order total immediately above "Go To Checkout", so the
      customer sees what they are about to pay without scrolling back up.
   2. When Zapiet has enough address detail on the cart, asks Shopify what the
      delivery will cost and shows it beside the total, instead of leaving the
      customer with "eligible for delivery" and no price. */
(function () {
  'use strict';

  function onCartPage() {
    return /\/cart(\/|$|\?)/.test(location.pathname + location.search);
  }

  function getCart() {
    var now = Date.now();
    var c = window.__bbCartCache;
    if (c && c.p && (now - c.t) < 600) return c.p;
    var p = fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .catch(function (e) { window.__bbCartCache = null; throw e; });
    window.__bbCartCache = { t: now, p: p };
    return p;
  }

  var PRIORITY_VARIANT = 39568791863381;

  function priorityCents(cart) {
    var l = (cart.items || []).filter(function (i) {
      return Number(i.variant_id) === PRIORITY_VARIANT;
    })[0];
    return l ? l.final_line_price : 0;
  }

  function money(cents) {
    return '$' + (Number(cents || 0) / 100).toFixed(2);
  }

  /* ---------- delivery rate ----------
     Zapiet works out the fee inside its own carrier service, which Shopify
     only calls at checkout - /cart/shipping_rates.json never returns it. So we
     read the postcode the customer typed into Zapiet's own field and look it
     up in the same rate table the product page uses. */

  function deliveryActive() {
    var tabs = document.querySelectorAll('.checkoutMethod');
    for (var i = 0; i < tabs.length; i++) {
      if (tabs[i].classList.contains('active')) return /delivery/i.test(tabs[i].innerText || '');
    }
    return false;
  }

  function typedPostcode() {
    var f = document.getElementById('deliveryGeoSearchField');
    var v = f && f.value ? String(f.value) : '';
    var m = v.match(/\b(\d{4})\b/);
    return m ? m[1] : '';
  }

  /* Zapiet's own "you are eligible" sentence - the hook the price hangs off */
  function eligibleLine() {
    var nodes = document.querySelectorAll('#storePickupApp p, #storePickupApp div');
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      if (n.children.length === 0 && /eligible for delivery/i.test(n.textContent)) return n;
    }
    return null;
  }

  function eligibleShown() {
    return !!eligibleLine();
  }

  /* Zapiet rewrites its own panel every second or so, which briefly removes
     the "eligible" line. Without a memory the price would blink out and back.
     Hold the last answer while the method and postcode are unchanged. */
  var lastRate = null;

  function currentRate() {
    if (!deliveryActive()) { lastRate = null; return null; }
    var zip = typedPostcode();
    if (!zip) { lastRate = null; return null; }
    if (lastRate && lastRate.zip === zip) return lastRate;
    if (!eligibleShown()) return null;
    var table = window.__bbDeliveryRates || {};
    if (!Object.prototype.hasOwnProperty.call(table, zip)) { lastRate = null; return null; }
    lastRate = { zip: zip, cents: Math.round(Number(table[zip]) * 100) };
    return lastRate;
  }

  /* ---------- the block above the checkout button ---------- */

  function host() {
    /* scope to the cart page footer - the drawer has a .cart__ctas too and it
       comes first in the DOM, so an unscoped query lands in the wrong place */
    var foot = document.getElementById('main-cart-footer');
    var ctas = foot && foot.querySelector('.cart__ctas');
    if (!ctas) return null;
    var el = document.getElementById('bb-cart-total');
    if (!el || el.parentElement !== ctas) {
      if (el) el.remove();
      el = document.createElement('div');
      el.id = 'bb-cart-total';
      el.className = 'bb-cart-total';
      ctas.insertBefore(el, ctas.firstChild);
    }
    return el;
  }

  function paint(cart, rate) {
    var el = host();
    if (!el) return;
    /* reuse the theme's own totals markup so this matches "Your Total:" exactly */
    function row(label, value, cls) {
      return '<div class="totals' + (cls ? ' ' + cls : '') + '">' +
               '<h2 class="totals__total">' + label + '</h2>' +
               '<p class="totals__total-value">' + value + '</p>' +
             '</div>';
    }
    var pri = priorityCents(cart);
    var del = rate ? rate.cents : 0;
    var html = '';
    if (del || pri) {
      /* the priority line is already inside the cart total, so back it out of
         the items figure and show it on its own line */
      html += row('Items:', money(cart.total_price - pri), 'bb-cart-total__sub');
      if (del) html += row('Delivery:', money(del), 'bb-cart-total__sub');
      if (pri) html += row('Priority delivery:', money(pri), 'bb-cart-total__sub');
      html += row('Total to pay:', money(cart.total_price + del));
    } else {
      html += row('Your Total:', money(cart.total_price));
    }
    if (el.innerHTML !== html) el.innerHTML = html;
    placeTerms(el);
  }

  /* the policy tick belongs with the button that it gates, not up in the
     middle of the summary - it is the theme's own element, and the checkout
     guard finds it by id, so moving it is safe */
  function placeTerms(totalsEl) {
    var terms = document.getElementById('terms-container');
    var ctas = totalsEl && totalsEl.parentElement;
    if (!terms || !ctas) return;
    if (terms.previousElementSibling === totalsEl) return;
    ctas.insertBefore(terms, totalsEl.nextSibling);
    terms.classList.add('bb-terms');
  }

  /* Zapiet rebuilds this paragraph constantly and strips anything we append,
     so instead of fighting it we render the price as a ::after on its own
     paragraph and just feed the text through a CSS variable. */
  function paintEligible(rate) {
    var v = rate ? '" Delivery to ' + rate.zip + ' is ' + money(rate.cents) + '."' : '""';
    var el = document.documentElement;
    if (el.style.getPropertyValue('--bb-delivery-note') !== v) {
      el.style.setProperty('--bb-delivery-note', v);
    }
  }

  /* ---------- run ---------- */

  var busy = false;
  var lastCart = null;
  var lastCartAt = 0;

  /* DOM-only repaint - no network, so it can run often enough to survive
     Zapiet wiping our line out of its panel */
  function tick() {
    /* any cart change anywhere clears the shared cache - that is our cue to
       re-read, so the totals follow the cart without anyone wiring up events */
    /* Re-read when a cart change cleared the shared cache, plus a slow safety
       net in case a signal is ever missed. Never while the app is mid-write:
       Shopify queues cart requests per session, so a read squeezed in there
       adds seconds to Zapiet's own call and to its spinner. */
    if (!busy && !appBusy() && (!window.__bbCartCache || Date.now() - lastCartAt > 10000)) refresh();
    if (!lastCart) return;
    var rate = currentRate();
    paint(lastCart, rate);
    paintEligible(rate);
    mountClear(lastCart);
  }

  /* Shopify queues cart requests per session. Zapiet's calendar call, its
     cart writes, and anything the theme fires off the back of them all share
     that queue, so one read of ours squeezed in there is what turns Zapiet's
     ~400ms write into a ~1.7s one. Wait the burst out instead of dropping the
     read - every caller below funnels through here, so nothing can slip past. */
  var refreshWait = null;
  function appBusy() {
    return (window.__bbCartBusy || 0) > 0 ||
           (Date.now() - (window.__bbCartLastMut || 0) < 3000);
  }
  function refresh() {
    if (busy) return;
    if (appBusy()) {
      clearTimeout(refreshWait);
      refreshWait = setTimeout(refresh, 700);
      return;
    }
    busy = true;
    getCart().then(function (cart) {
      lastCart = cart;
      lastCartAt = Date.now();
      tick();
    }).catch(function () {}).then(function () { busy = false; });
  }

  function watch() {
    var footer = document.getElementById('main-cart-footer');
    if (!footer) return;
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      setTimeout(function () { pending = false; refresh(); }, 700);
    }).observe(footer, { childList: true, subtree: true });
  }

  /* ---------- clear cart ----------
     One control for "empty this and start again", sitting beside Continue
     shopping. Confirms inline rather than with a browser dialog, and reloads
     afterwards so Zapiet and the theme's own cart sections resync from a
     clean slate instead of being patched line by line. */
  var CLEAR_ID = 'bb-clear';

  /* Lines the customer never put there (the mandatory processing line, and
     bundle children) should not keep the control alive on an empty cart. */
  function visibleItems(cart) {
    return (cart.items || []).filter(function (i) {
      var p = i.properties || {};
      return !p._mandatory && !p._Child;
    }).length;
  }

  function clearHost() {
    return document.querySelector('#bb-cartbox .title-wrapper-with-link') ||
           document.querySelector('cart-items .page-width .title-wrapper-with-link');
  }

  var BIN_SVG =
    '<svg class="bb-clear__bin" viewBox="0 0 16 16" fill="none" stroke="currentColor" ' +
    'stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' +
    '<path d="M2.5 4h11M6 4V2.6h4V4M4 4l.7 9.4h6.6L12 4"/></svg>';
  var IDLE_HTML = '<button type="button" class="bb-clear__btn" data-bb-clear="ask">' + BIN_SVG + 'Clear cart</button>';
  var ASK_HTML =
    '<span class="bb-clear__ask">Clear cart?</span>' +
    '<button type="button" class="bb-clear__btn bb-clear__yes" data-bb-clear="yes">Yes, clear it</button>' +
    '<button type="button" class="bb-clear__link" data-bb-clear="no">Cancel</button>';

  /* Both controls live in one group so they stay side by side and travel to
     the next line together when the heading row runs out of width. The theme's
     "Continue shopping" link is moved into the group rather than duplicated,
     and put back before the group is ever removed. */
  function detachLink(host) {
    var box = document.getElementById(CLEAR_ID);
    var link = box && box.querySelector('.underlined-link');
    if (link && host) host.appendChild(link);
  }

  function mountClear(cart) {
    var host = clearHost();
    var box = document.getElementById(CLEAR_ID);
    var n = visibleItems(cart);
    /* With a clear-all button the empty cart is a state customers will
       actually land on, so drop the two bordered panels rather than leaving
       empty boxes floating above "Your cart is empty". */
    document.documentElement.setAttribute('data-bb-cart-empty', n ? '0' : '1');
    if (!host || !n) { if (box) { detachLink(host); box.remove(); } return; }
    if (!box) {
      box = document.createElement('div');
      box.id = CLEAR_ID;
      box.className = 'bb-clear';
      box.innerHTML = IDLE_HTML;
    }
    if (box.parentNode !== host) host.appendChild(box);
    var link = host.querySelector(':scope > .underlined-link');
    if (link) box.appendChild(link);
  }

  /* innerHTML swaps would throw the moved link away - lift it out first and
     put it back after. */
  function swapClear(html) {
    var box = document.getElementById(CLEAR_ID);
    if (!box) return null;
    var link = box.querySelector('.underlined-link');
    box.innerHTML = html;
    if (link) box.appendChild(link);
    return box;
  }

  function resetClear() {
    var box = document.getElementById(CLEAR_ID);
    if (box && box.getAttribute('data-state') === 'ask') {
      box.removeAttribute('data-state');
      swapClear(IDLE_HTML);
    }
  }

  function doClear() {
    var box = document.getElementById(CLEAR_ID);
    if (box) {
      box.setAttribute('data-state', 'busy');
      swapClear('<span class="bb-clear__ask">Clearing<span class="bb-pd-spin"></span></span>');
      box.classList.add('bb-clear--busy');
    }
    window.__bbCartCache = null;
    var json = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
    fetch('/cart/clear.js', { method: 'POST', credentials: 'same-origin', headers: json })
      .then(function () {
        /* the postcard card reads these to decide whether a postcard is
           already in the cart - leave them set and it stays hidden */
        return fetch('/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Postmut-Guard': '1' },
          body: JSON.stringify({ attributes: { 'Postcard Message': '', 'Postcard For': '' } })
        });
      })
      .catch(function () {})
      .then(function () { location.reload(); });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    var btn = t && t.closest ? t.closest('[data-bb-clear]') : null;
    if (!btn) { if (!(t && t.closest && t.closest('#' + CLEAR_ID))) resetClear(); return; }
    var action = btn.getAttribute('data-bb-clear');
    if (action === 'ask') {
      var box = document.getElementById(CLEAR_ID);
      if (box) { box.setAttribute('data-state', 'ask'); swapClear(ASK_HTML); }
    } else if (action === 'no') {
      resetClear();
    } else if (action === 'yes') {
      doClear();
    }
  });

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') resetClear(); });

  /* ---------- self-check ----------
     Everything here hangs off Zapiet's markup and the theme's cart markup. If
     either ships a change that renames an element, the feature that needs it
     already fails quiet (each one bails when its anchor is missing) - this
     records WHICH anchor went so it shows up in a console check or a smoke
     test instead of being found by a customer. DOM reads only, no network. */
  function health() {
    var deliveryOn = deliveryActive();
    var checks = [
      ['zapiet-widget',   !!document.getElementById('storePickupApp'), true],
      ['method-tabs',     document.querySelectorAll('.checkoutMethod').length === 3, true],
      ['cart-items',      !!document.querySelector('#main-cart-items table.cart-items tbody'), true],
      ['checkout-ctas',   !!(document.getElementById('main-cart-footer') || {}).querySelector, true],
      ['rate-table',      !!(window.__bbDeliveryRates && Object.keys(window.__bbDeliveryRates).length), true],
      ['postcode-field',  !!document.getElementById('deliveryGeoSearchField'), deliveryOn],
      ['date-field',      !!document.getElementById('Zapiet-InputCalendar__deliveryDate_ISO'), deliveryOn],
      ['priority-toggle', !!document.getElementById('gift-wrapping'), deliveryOn],
      ['eligible-hook',   !!document.querySelector('#storePickupApp .delivery_success'), deliveryOn && eligibleShown()]
    ];
    var missing = [];
    checks.forEach(function (c) { if (c[2] && !c[1]) missing.push(c[0]); });
    var out = { ok: missing.length === 0, missing: missing, delivery: deliveryOn, at: new Date().toISOString() };
    window.__bbHealth = out;
    document.documentElement.setAttribute('data-bb-health', out.ok ? 'ok' : missing.join(','));
    if (!out.ok && window.__bbHealthLogged !== missing.join(',')) {
      window.__bbHealthLogged = missing.join(',');
      try { console.warn('[Bluebells cart] missing anchors:', missing.join(', ')); } catch (e) {}
    }
    return out;
  }

  function boot() {
    if (!onCartPage()) return;
    refresh();
    setTimeout(refresh, 1500);
    setTimeout(refresh, 4000);
    setInterval(tick, 500);
    setTimeout(health, 3000);
    setInterval(health, 5000);
    watch();
    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('#storePickupApp')) setTimeout(refresh, 1500);
    });
    document.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('#storePickupApp')) setTimeout(refresh, 1200);
    });
    document.addEventListener('keyup', function (e) {
      if (e.target && e.target.id === 'deliveryGeoSearchField') setTimeout(refresh, 1200);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
}());
